import {SectionPaddingBottom, SectionPaddingHalfBottom, SectionPaddingHalfTop} from '@/section';
import {Grid, Row, Col} from '@/grid';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import Container from '@/container';
import BoxGrid from '@/ui/box-grid';
import {H1, P, PNoMargin} from '@/typography';
import {withHomeSubP} from '@/hocs/withFontType';
import {withMarginBottomXs} from '@/hocs/withSpacing';
import {withNeutral800, withGreen800} from '@/hocs/withColors';

const H1Green800 = withGreen800(H1);
const SubPNeutral800 = withNeutral800(withHomeSubP(PNoMargin));
const PMarginXs = withMarginBottomXs(PNoMargin);

const UsefulLinksArray = [
  {
    url: 'https://workable.readme.io/',
    urlCopy: 'View API documentation',
    title: 'Workable users',
    copy: 'Use our API to show jobs on your website, get data from your Workable account, or bring in candidates from other systems.',
    target: '_blank'
  },
  {
    url: '/developers/#partners-api',
    urlCopy: 'Explore partner program',
    title: 'Workable partners',
    copy: 'Workable sits at the heart of modern hiring. Get deeper API access to connect your product directly with Workable, making it available to thousands of companies.'
  }
];

const HeroSection = () => (
  <>
    <SectionPaddingHalfBottom>
      <Container variant="section-padding-below-nav">
        <SectionPaddingHalfTop>
          <Grid fluid>
            <Row center="xs">
              <Col xs={12} lg={8}>
                <H1Green800>Developer API</H1Green800>
                <SubPNeutral800>
                  Connect Workable with your existing tools or build custom solutions. Our API makes
                  integrations straightforward for both Workable users and integration partners.
                </SubPNeutral800>
              </Col>
            </Row>
          </Grid>
        </SectionPaddingHalfTop>
      </Container>
    </SectionPaddingHalfBottom>
    <SectionPaddingBottom>
      <Container>
        <Grid fluid>
          <GridLayout Col={2} lgCol={2} autoRows>
            {UsefulLinksArray.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <GridItem key={index}>
                <BoxGrid
                  backgroundColor="var(--brown50)"
                  Url={item.url}
                  UrlCopy={item.urlCopy}
                  minHeight={288}
                  {...(item.target && {target: item.target})}>
                  <PMarginXs className="heading-3">{item.title}</PMarginXs>
                  <P>{item.copy}</P>
                </BoxGrid>
              </GridItem>
            ))}
          </GridLayout>
        </Grid>
      </Container>
    </SectionPaddingBottom>
  </>
);

export default HeroSection;
